
/**
 * @export
 * @enum {string}
 */
export enum SsoStatus {
    IN_PROGRESS = 'IN_PROGRESS',
    FINALIZED = 'FINALIZED',
    ERROR = 'ERROR'
}